module.exports = __webpack_public_path__ + "static/media/pattern.8f90611d.png";